import * as types from 'actions/actionTypes';
import initialState from 'reducers/initialState';

export default (state = initialState.validationMessage, action) => {
  switch (action.type) {
    case types.VALIDATION_MSG_HAS:
      return action.validationMessage;

    case types.VALIDATION_MSG_NONE:
      return {};

    case types.LOG_OUT.SUCCESS:
      return initialState.validationMessage;

    default:
      return state;
  }
};
